import { Component, OnInit,TemplateRef } from "@angular/core";
import { LocationService } from "../../services/location.service";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FixedContentComponent } from "../mobile/fixed-content/fixed-content.component";
@Component({
  selector: "app-select-location",
  templateUrl: "./select-location.component.html",
  styleUrls: ["./select-location.component.scss"]
})
export class SelectLocationComponent implements OnInit {
  constructor(
    private locationService: LocationService,
    private fixedContentComponent: FixedContentComponent,
    private country: LocationService,
    private modalService: BsModalService,
  ) {}
  selectedOption;
  stateList;
  cityList;
  i = 0;
  data_JSON: any;
  data_State: any;
  data_City: any;
  data_Country: any;
  sele: any;
  modalRef: BsModalRef;
  stateId;
  cityId;
  onCountrySelect($event) {
    this.i = $event.target.options.selectedIndex;
    this.locationService.setSelectedCountry(this.i);
  }
  changeLocation(): any {
    this.locationService.setData(this.selectedOption);
  }

  getCountries() {
    this.country.allCountries().subscribe(
      data_JSON => {
        var cdat = { term: "All countries", "term id": "all" };
        data_JSON.splice(0, 0, cdat);
        this.data_Country = data_JSON;
      },
      err => console.log(err)
    );
  }
 
  onChangeCountry(countValue) {
    this.data_City = [];
    this.country.allStates(countValue).subscribe(
      data_State => {
        let stateArray = [];
        for (let i = 0; i < data_State.length; i++) {
          var cData = data_State[i];
          var cName = cData.term;
          if (cName.toLowerCase() === "all states") {
            stateArray.splice(0, 0, cData);
          } else {
            stateArray.push(cData);
          }
        }

        this.data_State = stateArray;
      },
      err => console.log(err)
    );
  }

  onChangeState(stateValue) {
    this.country.allCity(stateValue).subscribe(
      data_City => {
        let cityArray = [];
        for (let i = 0; i < data_City.length; i++) {
          var cData = data_City[i];
          var cName = cData.term;
          if (cName.toLowerCase() === "all cities") {
            cityArray.splice(0, 0, cData);
          } else {
            cityArray.push(cData);
          }
        }

        this.data_City = cityArray;
     
      },
      err => console.log(err)
    );
  }

  ngOnInit() {
    this.getCountries();
    this.i = this.locationService.getSelectedCountry();
    console.log(this.i);
    // this.selectedOption = this.data_JSON[this.i].name;
  }
}
